var MpPageLegislationTag;

(function() {
    if (!document.querySelector('#vue-body-legislation-tag')) {
        return;
    }

    MpPageLegislationTag = new Vue({
        el: '#vue-body-legislation-tag',
        mixins: [MpBaseLegislation],
        data: {
            LEGISLATION_URL: '/legislation/tags/format/json/page/',

            totalResultsTPL: '',
            totalItems: 0,
        },

        computed: {},

        methods: {

            loadItems: function(isPagination) {
                if (!isPagination && this.page !== 1) {
                    this.setPage(1);
                }

                // Set proper filters value depending the request type
                this.filters = (!isPagination) ? (this.filters || 'ok') : '';

                axios
                    .post(this.LEGISLATION_URL + this.page, this.dataFilters)
                    .then(this.onItemsLoaded)
                    .catch(function(error) {
                        console.log(error);
                    });
            },

            sendForm: function() {
                // TODO: validate filters?
                if (true) {
                    this.loadItems();
                }
            }
        },
        filters: {},

        mounted: function() {
            this.$refs.ssrItemList.querySelectorAll('.js-item').forEach(this.addDomItem);

            this.totalResultsTPL = this.$refs.ssrTotalItems.getAttribute('data-tpl');
            this.totalItems = this.$refs.ssrTotalItems.getAttribute('data-total');
        },

    });

})();
